import timeZone from 'moment-timezone';

const TZ = 'Asia/Shanghai';

export const filterOrdersByCreatedDateRange = (orders = [], startDate, endDate, dateField = 'createdAt') => {
	if (!startDate || !endDate) return orders;
	const rangeStart = timeZone.tz(startDate, TZ).startOf('day');
	const rangeEnd = timeZone.tz(endDate, TZ).endOf('day');
	if (!rangeStart.isValid() || !rangeEnd.isValid()) return orders;

	return orders.filter((order) => {
		const raw = dateField === 'completedAt' ? order?.completedAt : order?.createdAt;
		if (!raw) return false;
		const axisDate = timeZone.tz(raw, TZ);
		return axisDate.isValid() && axisDate.isBetween(rangeStart, rangeEnd, null, '[]');
	});
};

export default filterOrdersByCreatedDateRange;
